import React, { useState } from "react";
import AppBar from "./AppBar";
import MemberStrip from "./MemberStrip";
import { useMandate } from "./MandateContext";

const PROVIDERS = [
  {
    id: "PHONEPE",
    label: "Navadhan UPI Autopay",
    subtitle: "Powered by NPCI UPI AutoPay",
    pills: ["Instant Setup", "All UPI Apps", "QR Support"],
    helper: "Tap any UPI app — it opens automatically with mandate details pre-filled",
    color: "#0178B7",
    abbr: "Pe",
    selBg: "#f5f0ff",
    selBorder: "#0178B7",
  },
  // {
  //   id: "RAZORPAY",
  //   label: "Razorpay UPI Autopay",
  //   subtitle: "Powered by Razorpay Recurring",
  //   pills: ["Instant Setup", "UPI & NACH", "Bank Mandate"],
  //   helper: "Tap any UPI app — it opens automatically with mandate details pre-filled",
  //   color: "#2563eb",
  //   abbr: "Rp",
  //   selBg: "#eff6ff",
  //   selBorder: "#2563eb",
  // },
];

export default function ProviderSelection({ onNext, onBack }) {
  const { state, update } = useMandate();
  const [selected, setSelected] = useState(state.provider || null);

  function handleContinue() {
    if (!selected) return;
    update({ provider: selected });
    onNext();
  }

  const provLabel = selected ? (PROVIDERS.find((p) => p.id === selected) || {}).label || "" : "";

  return (
    <section className="main-sec" style={{ minHeight: "100vh" }}>
      <div className="container fix-width">
      <AppBar title="Choose Provider" onBack={onBack} />
      <MemberStrip memberName={(state.selectedMember && state.selectedMember.memberName) || ""} />

      <div style={{ padding: "20px 0 20px" }}>

        {/* Brand header */}
        {/* <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{
            width: 56, height: 56, borderRadius: "50%", background: "#166534",
            display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 6,
          }}>
            <span style={{ color: "#fff", fontWeight: 900, fontSize: 24 }}>N</span>
          </div>
          <div style={{ fontWeight: 700, fontSize: 17, color: "#166534" }}>Navadhan</div>
          <div style={{ fontSize: 12, color: "#6b7280" }}>
            Set up autopay for seamless loan repayments for{" "}
            <strong>{state.selectedMember && state.selectedMember.memberName}</strong>
          </div>
        </div> */}

        {/* <div style={{ fontWeight: 700, fontSize: 13, color: "#374151", marginBottom: 10 }}>
          Select your preferred autopay method
        </div> */}

        {PROVIDERS.map((p) => {
          const isSel = selected === p.id;
          return (
            <div
              key={p.id}
              onClick={() => setSelected(p.id)}
              style={{
                background: isSel ? p.selBg : "#fff",
                border: isSel ? `2px solid ${p.selBorder}` : "1px solid #e5e7eb",
                borderRadius: 16,
                padding: "12px 14px",
                marginBottom: 14,
                cursor: "pointer",
                position: "relative",
              }}
            >
              {isSel && (
                <div style={{
                  position: "absolute", top: 10, right: 10,
                  width: 14, height: 14, borderRadius: "50%", background: p.color,
                }} />
              )}
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: "50%", background: p.color,
                  color: "#fff", display: "flex", alignItems: "center",
                  justifyContent: "center", fontWeight: 700, fontSize: 15, flexShrink: 0,
                }}>
                  {p.abbr}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{p.label}</div>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>{p.subtitle}</div>
                </div>
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
                {/* {p.pills.map((pill) => (
                  <span
                    key={pill}
                    style={{
                      background: isSel ? p.color : "#f3f4f6",
                      color: isSel ? "#fff" : "#374151",
                      borderRadius: 20,
                      padding: "2px 10px",
                      fontSize: 11,
                      fontWeight: 500,
                    }}
                  >
                    {pill}
                  </span>
                ))} */}
              </div>
              {/* <div style={{ fontSize: 11, color: "#6b7280", borderTop: "1px solid #f3f4f6", paddingTop: 8 }}>
                {p.helper}
              </div> */}
            </div>
          );
        })}

        {/* Mandate summary */}
        {/* <div style={{
          background: "#f5f0ff", border: "1px solid #e9d5ff",
          borderRadius: 12, padding: "8px 12px",
          display: "flex", alignItems: "center", gap: 8, marginBottom: 16,
        }}>
          <span style={{ fontSize: 18 }}>🔁</span>
          <span style={{ fontSize: 12, color: "#4b5563" }}>
            Monthly · <strong>₹649 max</strong> · Starts today · Navadhan
          </span>
        </div> */}

        <button
          style={{
            background: selected ? "#0178B7" : "#d1d5db",
            color: "#fff",
            borderRadius: 8,
            border: "none",
            cursor: selected ? "pointer" : "not-allowed",
            width: "100%",
            fontWeight: 700,
            marginBottom: 12,
            padding: "12px 0",
            fontSize: 15,
          }}
          disabled={!selected}
          onClick={handleContinue}
        >
          {selected ? `Continue with ${provLabel}` : "Select a provider to continue"}
        </button>
      </div>

      </div>
    </section>
  );
}
